var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data"},[_c('div',[_c('img',{staticClass:"no_data_img",attrs:{"src":require("../../assets/img/no_data.png"),"alt":""}}),_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm.$t('main.text28')))]),_c('p',{staticClass:"p2"},[_vm._v(_vm._s(_vm.$t('main.text29')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }